<template>
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10.1432 1.42372C10.5319 0.777902 11.4681 0.777901 11.8568 1.42372L14.7315 6.20042C14.8711 6.43243 15.0988 6.5979 15.3626 6.65899L20.7939 7.91688C21.5282 8.08695 21.8175 8.97742 21.3234 9.54662L17.6688 13.7567C17.4913 13.9612 17.4043 14.2289 17.4277 14.4987L17.9098 20.0528C17.9749 20.8037 17.2174 21.354 16.5234 21.06L11.3901 18.8853C11.1408 18.7796 10.8592 18.7796 10.6099 18.8853L5.47659 21.06C4.78256 21.354 4.02508 20.8037 4.09025 20.0528L4.57227 14.4987C4.59568 14.2289 4.50869 13.9612 4.33118 13.7567L0.676593 9.54662C0.182485 8.97742 0.471816 8.08695 1.20613 7.91688L6.63735 6.65899C6.90116 6.5979 7.12891 6.43243 7.26853 6.20042L10.1432 1.42372Z"
        />
    </svg>
</template>

<script>
export default {
    setup() {
        return {};
    }
};
</script>

<style lang="scss" scoped></style>
